<template>
    <section class="quote-section">
        <header class="quote-section-header">
            <div class="container">
                <div class="inner">
                    <h2 v-text="lang('Richiesta Preventivo')"></h2>

                    <div class="steps">
                        <div class="step" @click.prevent="navigateToStep('type')"
                             :class="{ 'active': isActiveStep('type') || completedStep.type }">
                            <div class="icon"></div>
                            <div class="text" v-text="lang('Seleziona Tipologia')"></div>
                        </div>
                        <div class="step" @click.prevent="navigateToStep('registry')"
                             :class="{ 'active': isActiveStep('registry') || completedStep.registry }">
                            <div class="icon"></div>
                            <div class="text" v-text="lang('Dati Anagrafici')"></div>
                        </div>
                        <div class="step" @click.prevent="navigateToStep('project')"
                             :class="{ 'active': isActiveStep('project') || completedStep.project }">
                            <div class="icon"></div>
                            <div class="text" v-text="lang('Dati Cantiere')"></div>
                        </div>
                        <div v-if="type === 'request'" @click.prevent="navigateToStep('upload')" class="step"
                             :class="{ 'active': isActiveStep('upload') || completedStep.upload }">
                            <div class="icon"></div>
                            <div class="text" v-text="lang('Carica Documenti')"></div>
                        </div>
                        <div class="step" @click.prevent="navigateToStep('review')"
                             :class="{ 'active': isActiveStep('review') || completedStep.review }">
                            <div class="icon"></div>
                            <div class="text" v-text="lang('Rivedi dati')"></div>
                        </div>
                        <div class="step" @click.prevent="navigateToStep('send')"
                             :class="{ 'active': isActiveStep('send') || completedStep.send }">
                            <div class="icon"></div>
                            <div class="text" v-text="lang('Richiedi Preventivo')"></div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div v-if="throttled.error" class="container">
            <div class="notification is-warning" v-text="throttled.message"></div>
        </div>
        <div class="quote-section-body">
            <div v-if="loading && !sending" class="quote-loader">
                <div class="icon"><i class="fas fa-5x fa-spin fa-circle-notch"></i></div>
            </div>
            <quote-form-type v-show="isActiveStep('type') && ! loading && ! sended" v-model="type"
                             @completed="activateButton"></quote-form-type>
            <quote-form-registry :provinces="assets.provinces" :countries="assets.countries" :titles="assets.titles" :buyersTypes="filteredBuyersTypes"
                                 v-show="isActiveStep('registry') && ! loading && ! sended" :errors="errors"
                                 v-model="registry" @completed="activateButton"></quote-form-registry>
            <quote-form-project :provinces="assets.provinces"  :countries="assets.countries" :types="filteredTypes" :developmentStages="filteredDevelopmentStages"
                                v-show="isActiveStep('project') && ! loading && ! sended" :errors="errors" :type="type"
                                v-model="project" @completed="activateButton"></quote-form-project>
            <quote-form-upload v-show="isActiveStep('upload') && ! loading && ! sended" :errors="errors" v-model="files"
                               @completed="activateButton"></quote-form-upload>
            <quote-form-review :provinces="assets.provinces" :countries="assets.countries" :types="filteredTypes" :titles="assets.titles" :buyersTypes="assets.buyersTypes" :developmentStages="filteredDevelopmentStages"
                               v-show="isActiveStep('review') && ! loading && ! sended" @edit="navigateToStep"
                               :type="type" :files="files" :registry="registry" :project="project"
                               @completed="activateButton" :step="activeStep"></quote-form-review>
            <quote-form-policies v-show="isActiveStep('send') && ! loading && ! sended" :errors="errors"
                                 v-model="policies" @send="send"></quote-form-policies>
            <div v-if="sending" class="container">
                <h3 v-text="lang('Creazione Preventivo')"></h3>
                <progress class="progress is-primary" :value="progress.current" :max="progress.max"></progress>
                <p v-text="progress.text"></p>
            </div>
            <div class="container" v-if="sended">
                <h3><span v-text="lang(finish[this.type].title)"></span> <i class="fas fa-cog fa-pulse"></i></h3>
                <p v-text="lang(finish[this.type].text)"></p>
                <p v-if="policies.newsletter" v-text="finish.newsletter"></p>
            </div>
        </div>

        <footer v-if=" ! isActiveStep('send') && ! loading" class="quote-section-footer">
            <div class="container">
                <div class="buttons">
                    <button class="button is-text back-button mb-0">
                        <span class="icon"><i class="fas fa-angle-left"></i></span>
                        <span v-text="lang('Indietro')"></span>
                    </button>
                    <button :disabled="! buttonActive" @click.prevent="nextStep"
                            class="button is-primary mb-0" v-text="lang('Continua')"></button>
                </div>
            </div>
        </footer>

    </section>
</template>
<script>
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        data() {
            return {
                activeStep: 'type',
                buttonActive: false,
                loading: false,
                sending: false,
                sended: false,
                type: '',
                errors: {},
                files: [],
                endpoint: 'https://preventivi.daku.it',
                progress: {
                    current: 0,
                    max: 6,
                    text: ''
                },
                finish: {
                    online: {
                        title: 'Preventivo Inviato',
                        text: 'Grazie per aver utilizzato il nostro sistema di preventivazione. A breve riceverà una e-mail contente il preventivo generato. Vi ricordiamo inoltre la disponibiltà di contatto attraverso la nostra assistenza online. Grazie.'
                    },
                    request: {
                        title: 'Richiesta di preventivo inviata',
                        text: 'Grazie per aver utilizzato il nostro sistema di preventivazione. Il nostro incaricato di zona è stato avvisato della sua richiesta e si metterà in contatto entro 7 giorni. Vi ricordiamo inoltre la disponibiltà di contatto attraverso la nostra assistenza online. Grazie.'
                    },
                    newsletter: ''
                },
                registry: {
                    type: 'privato',
                    company: '',
                    firstname: '',
                    lastname: '',
                    title: '',
                    buyer_type: '',
                    email: '',
                    phone: '',
                    address: '',
                    city: '',
                    zip: '',
                    province: 1,
                    country: ''
                },
                project: {
                    subject: '',
                    stage_development: '',
                    type: '',
                    area: '',
                    province: 1,
                    country: '',
                    city: '',
                    description: ''
                },
                policies: {
                    privacy: false,
                    contact: false,
                    newsletter: false
                },
                completedStep: {
                    type: false,
                    registry: false,
                    project: false,
                    upload: false,
                    review: false,
                    send: false
                },
                assets: {
                    types: [],
                    provinces: [],
                    titles: [],
                    countries: [],
                    buyersTypes: [],
                    developmentStages: []
                },
                throttled: {
                    error: false,
                    message: ''
                }
            }
        },
        created() {
            let self = this;

            axios.get( this.endpoint+'/api/v1.0/provinces')
                .then(response => {

                  if(window.language === 'it') {
                    this.registry.country = 1;
                    this.project.country = 1;
                  }

                  this.assets.provinces = response.data
                })
                .catch(error => {
                    this.throttled.error = true;
                    this.throttled.message = error.response.data;
                });
            axios.get(this.endpoint+'/api/v1.0/titles')
                .then(response => {
                  response.data = _.filter(response.data, function (x) {
                    return _.trim(x.name) !== '';
                  });

                  response.data.splice(0, 0, {id : '', name: self.lang('Seleziona Qualifica')});

                  this.assets.titles = response.data
                })
                .catch(error => {
                    this.throttled.error = true;
                    this.throttled.message = error.response.data;
                });
            axios.get(this.endpoint+'/api/v1.0/types')
                .then(response => {
                  response.data = _.filter(response.data, function (x) {
                    return _.trim(x.name) !== '';
                  });

                  response.data.splice(0, 0, {id : '', name: self.lang('Seleziona Tipologia')});

                  this.assets.types = response.data
                })
                .catch(error => {
                    this.throttled.error = true;
                    this.throttled.message = error.response.data;
                });
            axios.get(this.endpoint+'/api/v1.0/countries')
                .then(response => {
                  response.data = _.filter(response.data, function (x) {
                    return _.trim(x.name) !== '';
                  });


                  if(window.language === 'en') {
                    this.registry.province = 1;
                    this.project.province = 1;
                  }

                  response.data.splice(0, 0, {id : '', name: self.lang('Seleziona Stato')});

                  this.assets.countries = response.data
                })
                .catch(error => {
                    this.throttled.error = true;
                    this.throttled.message = error.response.data;
                });
          axios.get(this.endpoint+'/api/v1.0/buyers-types')
              .then(response => {
                response.data = _.filter(response.data, function (x) {
                  return _.trim(x.name) !== '';
                });

                response.data.splice(0, 0, {id : '', name: self.lang('Seleziona Richiedente')});

                this.assets.buyersTypes = response.data
              })
              .catch(error => {
                this.throttled.error = true;
                this.throttled.message = error.response.data;
              });
          axios.get(this.endpoint+'/api/v1.0/development-stages')
              .then(response => {
                response.data = _.filter(response.data, function (x) {
                  return _.trim(x.name) !== '';
                });

                response.data.splice(0, 0, {id : '', name: self.lang('Seleziona Stato di sviluppo progetto')});

                this.assets.developmentStages = response.data
              })
              .catch(error => {
                this.throttled.error = true;
                this.throttled.message = error.response.data;
              });
        },
        methods: {
            isActiveStep(step) {
                return this.activeStep === step;
            },
            activateButton() {
                if (this.throttled.error) return;
                this.buttonActive = true;
            },
            deactivateButton() {
                this.buttonActive = false;
            },
            getNextStep() {
                switch (this.activeStep) {
                    case 'type':
                        return 'registry';
                        break;
                    case 'registry':
                        return 'project';
                        break;
                    case 'project':
                        return (this.type === 'request') ? 'upload' : 'review';
                        break;
                    case 'upload':
                        return 'review';
                        break;
                    case 'review':
                        return 'send';
                        break;
                    default:
                        return 'type';
                        break;
                }
            },
            nextStep() {
                if (this.throttled.error) return;
                this.errors = {};

                if (this.isActiveStep('type') || this.isActiveStep('review')) {
                    this.deactivateButton();
                    this.completedStep[this.activeStep] = true;
                    this.activeStep = this.getNextStep();
                } else {
                    this.loading = true
                    this.$set(this.validate, this.activeStep, true)
                    this.validate()
                        .then(response => {
                            this.deactivateButton();
                            this.completedStep[this.activeStep] = true;
                            if (this.getNextStep() === 'review') this.activateButton();
                            this.activeStep = this.getNextStep();
                            this.loading = false
                        })
                        .catch(error => {
                            this.$set(this.errors, this.activeStep, error.response.data)
                            this.loading = false
                        })
                }
            },
            validate() {
                return new Promise((resolve, reject) => {
                    axios.post(this.endpoint+'/api/v1.0/validate/' + this.activeStep, this.getObjectToValidate())
                        .then(response => {
                            resolve(response)
                        })
                        .catch(error => {
                                if (error.response.status === 403) {
                                    this.throttled.error = true;
                                    this.throttled.message = error.response.data;
                                }
                                reject(error)
                            }
                        )
                })
            },
            getObjectToValidate() {
                return this.getObjectToValidateByStep(this.activeStep)
            },
            getObjectToValidateByStep(step) {
                switch (step) {
                    case 'registry':
                        return this.registry;
                        break;
                    case 'project':
                        let obj = this.project;
                        obj.formType = this.type;
                        return obj;
                        break;
                    case 'send':
                        return this.policies;
                        break;
                    case 'upload':
                        let formData = new FormData();
                        for (let item of this.files) {
                            formData.append('files[]', item);
                        }
                        return formData;
                        break;
                }
            },
            navigateToStep(step) {
                if (this.completedStep[step]) {
                    this.activeStep = step;
                }
            },
            send() {
                this.loading = true;
                this.progress.max = 2 + this.files.length;
                if (this.policies.newsletter) this.progress.max++;

                axios.post(this.endpoint+'/api/v1.0/validate/policies', this.policies)
                    .then(response => {
                        this.sending = true;
                        this.createQuote();
                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            this.throttled.error = true;
                            this.throttled.message = error.response.data;
                        }
                        this.loading = false
                        this.$set(this.errors, 'policies', error.response.data)
                    })
            },
            async createQuote() {
                this.progress.text = this.lang("Creazione Preventivo");
                let response = await axios.post(this.endpoint+'/api/v1.0/quote', {
                    activity: (this.type === 'online') ? 6 : 1,
                    registry: this.getObjectToValidateByStep('registry'),
                    project: this.getObjectToValidateByStep('project'),
                    policies: this.getObjectToValidateByStep('send'),
                });
                this.progress.current++;
                let quote = response.data;

                if (!_.isEmpty(this.files)) {
                    for (let [index, file] of this.files.entries()) {
                        this.progress.text = `Upload document ${index + 1}/${this.files.length}`;
                        await this.upload(file, quote);
                    }
                }

                this.progress.text = this.lang("Invio Email");
                response = await axios.post(this.endpoint+'/api/v1.0/send', {
                    quote: quote.IDquote,
                    buyer: quote.IDbuyer,
                    contact: quote.IDbuyer_contact,
                    lang: window.language,
                    userType: this.registry.type,
                    description: this.project.description
                });
                this.progress.current++;

                if (this.policies.newsletter) {
                    this.progress.text = this.lang("Iscrizione Newsletter");
                    await axios.post('/dem/subscribe', {
                        firstname: this.registry.firstname,
                        lastname: this.registry.lastname,
                        email: this.registry.email,
                        privacy: true
                    })
                        .then(response => this.finish.newsletter = response.data);
                    this.progress.current++;
                }

                this.sending = false;
                this.loading = false;
                this.sended = true;

                return response;
            },
            upload(file, quote) {
                let formData = new FormData();
                formData.append('file', file);
                formData.append('quote', quote.IDquote);
                formData.append('buyer', quote.IDbuyer);

                let vue = this;
                return axios.post(this.endpoint+'/api/v1.0/upload', formData, {
                    onUploadProgress(progressEvent) {
                        vue.progress.current += (Math.floor((progressEvent.loaded * 100) / progressEvent.total)) / 100;
                    }
                }).catch(error => {
                    this.throttled.error = true;
                    this.throttled.message = error.response.data;
                });

            },
            setFiles(files) {
                this.files = files
            }
        },
        computed: {
          filteredBuyersTypes() {
            let self = this,
                type = self.registry.type;

            if(type === "") {
              return self.assets.buyersTypes.filter(function(item) {
                return !item.hasOwnProperty('visible_web');
              });
            } else if (type === 'privato') {
              return self.assets.buyersTypes.filter(function(item){
                return !item.hasOwnProperty('visible_web') || item.visible_web === 1 || item.visible_web === 2;
              });
            } else if (type === 'azienda') {
              return self.assets.buyersTypes.filter(function(item){
                return !item.hasOwnProperty('visible_web') || item.visible_web === 1 || item.visible_web === 3;
              });
            }
          },
          filteredDevelopmentStages() {
            let self = this,
                type = self.registry.type;

            if(type === "") {
              return self.assets.developmentStages.filter(function(item) {
                return !item.hasOwnProperty('visible_web');
              });
            } else if (type === 'privato') {
              return self.assets.developmentStages.filter(function(item){
                return !item.hasOwnProperty('visible_web') || item.visible_web === 1 || item.visible_web === 2;
              });
            } else if (type === 'azienda') {
              return self.assets.developmentStages.filter(function(item){
                return !item.hasOwnProperty('visible_web') || item.visible_web === 1 || item.visible_web === 3;
              });
            }
          },
          filteredTypes() {
            let self = this,
                type = self.registry.type;

            if(type === "") {
              return self.assets.types.filter(function(item) {
                return !item.hasOwnProperty('visible_web');
              });
            } else if (type === 'privato') {
              return self.assets.types.filter(function(item){
                return !item.hasOwnProperty('visible_web') || item.visible_web === 1 || item.visible_web === 2;
              });
            } else if (type === 'azienda') {
              return self.assets.types.filter(function(item){
                return !item.hasOwnProperty('visible_web') || item.visible_web === 1 || item.visible_web === 3;
              });
            }
          },
        }
    }
</script>
